import { axios } from '@ben/api/axios';
import { z } from 'zod';

const benefitDelaySchema = z.object({
  id: z.number(),
  type: z.string(),
  days: z.number().nullable(),
  name: z.string(),
});

const benefitDelaysSchema = z.array(benefitDelaySchema);

type BenefitDelays = z.infer<typeof benefitDelaysSchema>;

export const getBenefitDelays = async (): Promise<BenefitDelays> => {
  const response = await axios.get<BenefitDelays>('benefit-delays/');
  try {
    return benefitDelaysSchema.parse(response?.data);
  } catch {
    return response?.data;
  }
};
